export enum CommonPageStep {
  BLANK = 'blank',
  ENTRY = 'entry',
  LOGIN = 'login',
  SIGNUP = 'signup',
  SUBSCRIPTION = 'subscription',
  CHILD_PROFILE = 'child-profile',
  BIGBANGLAB = 'big-bang-lab',
  FORGETPASSWORD = 'forget-password',
  FORGETEMAIl = 'forget-email',
  RESETPASSWORD = 'reset-password',
  PARENT_PORTAL = 'parent-portal',
  NOTFOUND = 'not-found',
}

export enum SignupPageStep {
  CREATE_PARENT_ACCOUNT = 'create-parent-account',
  CREATE_PARENT_PROFILE = 'create-parent-profile',
  YOUR_CHILD_AGE = 'you-child-age',
}

export enum SubscriptionPageStep {
  CHOOSE_YOUR_PLAN = 'choose-your-plan',
}

export enum ThankyouPageStep {
  THANK_YOU = 'thank-you',
}

export enum ChildProfilePageStep {
  SELECT = 'select',
  CREATE = 'create',
  AVATAR = 'avatar',
  CREATED = 'created',
}

export enum BigBangLabPageStep {
  HOME = 'home', // HOME PAGE TO SHOW COURSE MAP
  TOPIC = 'topic', // TOPIC PAGE TO SHOW ALL TOPICS UNDER A CERTAIN COURSE
  LESSON = 'lesson', // LESSON PAGE TO SHOW ALL LESSONS UNDER A CERTAIN TOPIC
  STEP = 'step', // STEP PAGE TO SHOW VIDEO OR CHECKPOINT
  BLANK = 'blank', // STEP PAGE TO SHOW VIDEO OR CHECKPOINT
}

export enum ForgetPasswordPageStep {
  SUBMIT = 'submit',
  SENT = 'sent',
}

export enum ResetPasswordPageStep {
  RESET = 'reset',
  CHANGED = 'changed',
}

export enum ParentPortalPageStep {
  DASHBOARD = 'dashboard',
  GALLERY = 'gallery',
  SETTINGS = 'settings',
}

export interface AccountApiResponse {
  url?: string;
  success?: boolean;
  msg?: string;
  data?: any;
}

export enum PaPlan {
  bblProjectAlpha = 'PURCHASE_PROJECT_ALPHA',
  bblProjectAlphaYearly = 'PURCHASE_PROJECT_ALPHA_ANNUALLY',
  bblProjectAlphaBiyearly = 'PURCHASE_PROJECT_ALPHA_BIANNUALLY',
}

export enum SubscriptionPlan {
  bblMonthlySubscription = 'BBL_MONTHLY_SUBSCRIPTION',
  bblHalfYearSubscription = 'BBL_SEMI_ANNUALLY_SUBSCRIPTION',
  bblYearlySubscription = 'BBL_ANNUALLY_SUBSCRIPTION',
}

export enum Plans {
  bblProjectAlpha = 'PURCHASE_PROJECT_ALPHA',
  bblProjectAlphaYearly = 'PURCHASE_PROJECT_ALPHA_ANNUALLY',
  bblProjectAlphaBiyearly = 'PURCHASE_PROJECT_ALPHA_BIANNUALLY',
  bblMonthlySubscription = 'BBL_MONTHLY_SUBSCRIPTION',
  bblHalfYearSubscription = 'BBL_SEMI_ANNUALLY_SUBSCRIPTION',
  bblYearlySubscription = 'BBL_ANNUALLY_SUBSCRIPTION',
}

export enum SubscriptionPlanLabel {
  bblMonthlySubscription = 'Monthly Plan',
  bblHalfYearSubscription = 'Six-month Plan',
  bblYearlySubscription = 'Yearly Plan',
  bblProjectAlpha = 'Project Alpha',
}

export const subscriptionPlanName = (
  plan: string | undefined,
): SubscriptionPlanLabel => {
  switch (plan) {
    case Plans.bblProjectAlpha:
      return SubscriptionPlanLabel.bblProjectAlpha;
    case Plans.bblProjectAlphaYearly:
      return SubscriptionPlanLabel.bblProjectAlpha;
    case Plans.bblProjectAlphaBiyearly:
      return SubscriptionPlanLabel.bblProjectAlpha;
    case Plans.bblMonthlySubscription:
      return SubscriptionPlanLabel.bblMonthlySubscription;
    case Plans.bblHalfYearSubscription:
      return SubscriptionPlanLabel.bblHalfYearSubscription;
    case Plans.bblYearlySubscription:
      return SubscriptionPlanLabel.bblYearlySubscription;
    default:
      return SubscriptionPlanLabel.bblYearlySubscription;
  }
};

export enum SubscriptionPlanPrice {
  bblMonthlySubscription = 'HKD $599',
  bblHalfYearSubscription = 'HKD $2,874',
  bblYearlySubscription = 'HKD $4,308',
  bblProjectAlpha = 'HKD $8,000',
  bblProjectAlphaYearly = 'HKD $16,000',
}

export const NormalSubscriptionPlan = [
  Plans.bblMonthlySubscription,
  Plans.bblHalfYearSubscription,
  Plans.bblYearlySubscription,
];
export const ProjectAlphaSubscriptionPlan = [
  Plans.bblProjectAlpha,
  Plans.bblProjectAlphaYearly,
  Plans.bblProjectAlphaBiyearly,
];

export const enum SubscriptionMode {
  new = 'NEW',
  reactivate = 'REACTIVATE',
  add = 'ADD', // RESERVED FOR LATER, CHILD PROFILE BASED SUBSCRIPTION MODEL
  change = 'CHANGE',
  cancel = 'CANCEL',
}
